module.exports = __webpack_public_path__ + "img/9.275119a7.jpg";